import React from 'react'
import LayoutWithOutAccountCard from '../Layout/layout-without-card'

export default function LoanStatement() {
  return (
    <LayoutWithOutAccountCard
      breadCumKey='LOANS_VIEW_STATEMENT'
      keyPath={'DOWNLOAD_CENTER'}
      showEmptySpace={true}>
      <p>test works</p>
    </LayoutWithOutAccountCard>
  )
}
